<ng-container *ngIf="vm$ | async as vm">
  <div class="desktop-only">
    <div class="card px-2 py-1 mb-2 mt-1 flow-card">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="mx-3 mt-2">{{ 'general.change_flow.title' | translate }}</h2>
      </div>
      <p class="mx-3 flow-headline">{{ vm.monitoredUser.flow | flow }}</p>
      <div class="table-wrapper-mobile no-scroll">
        <table class="table mx-3 my-2 scoring-table">
          <colgroup>
            <col style="width: 30%" />
            <col style="width: 15%" />
            <col style="width: 15%" />
            <col style="width: 20%" />
            <col style="width: 20%" />
          </colgroup>
          <thead>
            <tr class="header">
              <th>{{ 'general.user_flow_table.table_header1' | translate }}</th>
              <th>{{ 'general.user_flow_table.table_header3' | translate }}</th>
              <th>{{ 'general.user_flow_table.table_header2' | translate }}</th>
              <th colspan="2">{{ 'general.user_flow_table.table_header4' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="5">
                <strong>{{ 'general.user_flow_table.must_score_headline' | translate }}</strong>
              </td>
            </tr>

            <!-- BMI (from scoreDetails; fallback computed) -->
            <tr class="striped-row">
              <td rowspan="3">
                <strong>{{ 'general.user_flow_table.bmi' | translate }}</strong>
              </td>
              <td class="striped-cell" rowspan="3">
                <strong>{{ vm.bmi }} Kg/m²</strong>
              </td>
              <td class="striped-cell" rowspan="3">
                <strong>{{ vm.bmiScore !== null ? vm.bmiScore : '—' }}</strong>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  {{ 'general.user_flow_table.bmi_1' | translate }}<br />
                  {{ 'general.user_flow_table.bmi_2' | translate }}<br />
                  {{ 'general.user_flow_table.bmi_3' | translate }}
                </div>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  2<br />
                  1<br />
                  0
                </div>
              </td>
            </tr>
            <tr class="striped-row"></tr>
            <tr class="striped-row"></tr>

            <!-- Weight Change (from scoreDetails; fallback store % if present) -->
            <tr class="striped-row">
              <td rowspan="3">
                <strong>{{ 'general.user_flow_table.weight_change' | translate }}</strong>
              </td>
              <td rowspan="3">
                <strong>{{ vm.weightChange !== null ? vm.weightChange + '%' : '—' }}</strong>
              </td>
              <td rowspan="3">
                <strong>{{ vm.weightChangeScore !== null ? vm.weightChangeScore : '—' }}</strong>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  {{ 'general.user_flow_table.weight_1' | translate }}<br />
                  {{ 'general.user_flow_table.weight_2' | translate }}<br />
                  {{ 'general.user_flow_table.weight_3' | translate }}
                </div>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  2<br />
                  1<br />
                  0
                </div>
              </td>
            </tr>
            <tr class="striped-row"></tr>
            <tr class="striped-row"></tr>

            <!-- Food Intake -->
            <tr class="striped-row">
              <td rowspan="3">
                <strong>{{ 'general.user_flow_table.food_intake' | translate }}</strong>
              </td>
              <td rowspan="3">
                <strong>
                  <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 2">
                    {{
                      vm.latestSubmissionDetails.questions[2].answers[0]
                        | answerDisplay
                          : vm.latestSubmissionDetails.questions[2].question
                          : vm.latestSubmissionDetails.questions[2].type
                          : vm.latestSubmissionDetails.questions[2].options ?? []
                        | translate
                    }}
                  </ng-container>
                </strong>
              </td>
              <!-- IMPORTANT: always render 0, so no *ngIf here -->
              <td rowspan="3">
                <strong>
                  {{ vm.foodIntakeScore !== null ? vm.foodIntakeScore : '—' }}
                </strong>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  {{ 'general.user_flow_table.intake_1' | translate }}<br />
                  {{ 'general.user_flow_table.intake_2' | translate }}<br />
                  {{ 'general.user_flow_table.intake_3' | translate }}
                </div>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  0<br />
                  1<br />
                  2
                </div>
              </td>
            </tr>
            <tr class="striped-row"></tr>
            <tr class="striped-row"></tr>

            <!-- slider questions -->
            <tr>
              <td colspan="5">
                <strong>{{
                  'general.user_flow_table.question_answers_headline' | translate
                }}</strong>
              </td>
            </tr>

            <!-- Question 1 -->
            <tr class="striped-row">
              <td rowspan="3">
                <strong>{{ 'general.user_flow_table.question_1' | translate }}</strong>
              </td>
              <td rowspan="3">
                <strong>
                  <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 0">
                    {{
                      vm.latestSubmissionDetails.questions[0].answers[0]
                        | answerDisplay
                          : vm.latestSubmissionDetails.questions[0].question
                          : vm.latestSubmissionDetails.questions[0].type
                          : vm.latestSubmissionDetails.questions[0].options ?? []
                        | translate
                    }}
                  </ng-container>
                </strong>
              </td>
              <td rowspan="3">
                <strong>{{ vm.question1Score !== null ? vm.question1Score : '—' }}</strong>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  {{ 'general.user_flow_table.score_low' | translate }}<br />
                  {{ 'general.user_flow_table.score_medium' | translate }}<br />
                  {{ 'general.user_flow_table.score_high' | translate }}
                </div>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  0<br />
                  1<br />
                  2
                </div>
              </td>
            </tr>
            <tr class="striped-row"></tr>
            <tr class="striped-row"></tr>

            <!-- Question 2 -->
            <tr class="striped-row">
              <td rowspan="3">
                <strong>{{ 'general.user_flow_table.question_2' | translate }}</strong>
              </td>
              <td rowspan="3">
                <strong>
                  <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 1">
                    {{
                      vm.latestSubmissionDetails.questions[1].answers[0]
                        | answerDisplay
                          : vm.latestSubmissionDetails.questions[1].question
                          : vm.latestSubmissionDetails.questions[1].type
                          : vm.latestSubmissionDetails.questions[1].options ?? []
                        | translate
                    }}
                  </ng-container>
                </strong>
              </td>
              <td rowspan="3">
                <strong>{{ vm.question2Score !== null ? vm.question2Score : '—' }}</strong>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  {{ 'general.user_flow_table.score_low' | translate }}<br />
                  {{ 'general.user_flow_table.score_medium' | translate }}<br />
                  {{ 'general.user_flow_table.score_high' | translate }}
                </div>
              </td>
              <td rowspan="3">
                <div class="left-border">
                  0<br />
                  1<br />
                  2
                </div>
              </td>
            </tr>
            <tr class="striped-row"></tr>
            <tr class="striped-row"></tr>

            <!-- flow assignment -->
            <tr>
              <td
                class="footer"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              >
                <strong>{{
                  'general.user_flow_table.flow_assignment_headline' | translate
                }}</strong>
              </td>
              <td
                class="footer"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              ></td>
              <td
                class="footer"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              >
                <strong>{{
                  vm.finalAssignmentScore !== null ? vm.finalAssignmentScore : '—'
                }}</strong>
              </td>
              <td
                class="footer"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              >
                <div class="left-border">
                  {{ 'general.user_flow_table.flow_low' | translate }}<br />
                  {{ 'general.user_flow_table.flow_medium' | translate }}<br />
                  {{ 'general.user_flow_table.flow_high' | translate }}
                </div>
              </td>
              <td
                class="footer borders right-bottom-border"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              >
                <div class="left-border">
                  {{ 'general.user_flow_table.flow_green' | translate }}<br />
                  {{ 'general.user_flow_table.flow_yellow' | translate }}<br />
                  {{ 'general.user_flow_table.flow_red' | translate }}
                </div>
              </td>
            </tr>
            <tr></tr>
            <tr></tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Mobile -->
  <div class="mobile-only scoring-table-mobile">
    <div class="card px-2 py-1 mb-2 mt-1 flow-card">
      <div class="d-flex justify-content-between align-items-center">
        <h2 class="mx-3 mt-2">{{ 'general.change_flow.title' | translate }}</h2>
      </div>
      <p class="mx-3 flow-headline">{{ vm.monitoredUser.flow | flow }}</p>
      <div class="table-wrapper-mobile">
        <table class="table mx-3 my-2">
          <colgroup>
            <col style="width: 70%" />
            <col style="width: 30%" />
          </colgroup>
          <thead>
            <tr class="header">
              <th>{{ 'general.user_flow_table.table_header1' | translate }}</th>
              <th>{{ 'general.user_flow_table.table_header2' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="table-headers" colspan="2">
                <strong>{{ 'general.user_flow_table.must_score_headline' | translate }}</strong>
              </td>
            </tr>

            <tr>
              <td class="table-sub-headers">{{ 'general.user_flow_table.bmi' | translate }}</td>
              <td class="table-sub-headers">
                <strong>{{ vm.bmi }} Kg/m²</strong>
              </td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.bmi_1' | translate }}</td>
              <td>2</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.bmi_2' | translate }}</td>
              <td>1</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.bmi_3' | translate }}</td>
              <td>0</td>
            </tr>

            <tr class="table-sub-headers">
              <td>{{ 'general.user_flow_table.weight_change' | translate }}</td>
              <td>
                <strong>{{ vm.weightChange !== null ? vm.weightChange + '%' : '—' }}</strong>
              </td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.weight_1' | translate }}</td>
              <td>2</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.weight_2' | translate }}</td>
              <td>1</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.weight_3' | translate }}</td>
              <td>0</td>
            </tr>

            <tr class="table-sub-headers">
              <td class="question">
                {{ 'general.user_flow_table.food_intake' | translate }}
              </td>
              <td class="answer">
                <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 2">
                  {{
                    vm.latestSubmissionDetails.questions[2].answers[0]
                      | answerDisplay
                        : vm.latestSubmissionDetails.questions[2].question
                        : vm.latestSubmissionDetails.questions[2].type
                        : vm.latestSubmissionDetails.questions[2].options ?? []
                      | translate
                  }}
                </ng-container>
              </td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.intake_1' | translate }}</td>
              <td>0</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.intake_2' | translate }}</td>
              <td>1</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.intake_3' | translate }}</td>
              <td>2</td>
            </tr>

            <tr>
              <td colspan="2">
                <strong>{{
                  'general.user_flow_table.question_answers_headline' | translate
                }}</strong>
              </td>
            </tr>
            <tr>
              <td class="table-sub-headers">
                {{ 'general.user_flow_table.question_1' | translate }}
              </td>
              <td class="table-sub-headers">
                <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 0">
                  {{
                    vm.latestSubmissionDetails.questions[0].answers[0]
                      | answerDisplay
                        : vm.latestSubmissionDetails.questions[0].question
                        : vm.latestSubmissionDetails.questions[0].type
                        : vm.latestSubmissionDetails.questions[0].options ?? []
                      | translate
                  }}
                </ng-container>
              </td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_low' | translate }}</td>
              <td>0</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_medium' | translate }}</td>
              <td>1</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_high' | translate }}</td>
              <td>2</td>
            </tr>

            <tr>
              <td class="table-sub-headers">
                {{ 'general.user_flow_table.question_2' | translate }}
              </td>
              <td class="table-sub-headers">
                <ng-container *ngIf="vm.latestSubmissionDetails?.questions?.length > 1">
                  {{
                    vm.latestSubmissionDetails.questions[1].answers[0]
                      | answerDisplay
                        : vm.latestSubmissionDetails.questions[1].question
                        : vm.latestSubmissionDetails.questions[1].type
                        : vm.latestSubmissionDetails.questions[1].options ?? []
                      | translate
                  }}
                </ng-container>
              </td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_low' | translate }}</td>
              <td>0</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_medium' | translate }}</td>
              <td>1</td>
            </tr>
            <tr>
              <td>{{ 'general.user_flow_table.score_high' | translate }}</td>
              <td>2</td>
            </tr>

            <tr>
              <td
                class="header"
                [ngClass]="{
                  'footer-red': vm.monitoredUser.flow === 'Red',
                  'footer-yellow': vm.monitoredUser.flow === 'Yellow',
                  'footer-green': vm.monitoredUser.flow === 'Green'
                }"
                rowspan="3"
              >
                <strong>{{
                  'general.user_flow_table.flow_assignment_headline' | translate
                }}</strong>
              </td>
              <td class="header borders right-bottom-border">
                {{ 'general.user_flow_table.flow_green' | translate }}
              </td>
            </tr>
            <tr>
              <td class="header borders right-border">
                {{ 'general.user_flow_table.flow_yellow' | translate }}
              </td>
            </tr>
            <tr>
              <td class="header borders right-top-border">
                {{ 'general.user_flow_table.flow_red' | translate }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-container>
